import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlpPageNameComponent } from './plp-page-name.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [PlpPageNameComponent],
  imports: [
    CommonModule,
    I18nModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        PlpPageName: {
          component: PlpPageNameComponent,
        },
      },
    }),
  ],
  exports: [PlpPageNameComponent],
})
export class PlpPageNameModule {}
